import type {
    AppDispatch,
    RootState,
} from '../store'
import {
    TypedAddListener,
    TypedStartListening,
    TypedStopListening,
    addListener,
    createListenerMiddleware,
} from '@reduxjs/toolkit'

const listener = createListenerMiddleware()

export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>

export const startAppListening = listener.startListening as TypedStartListening<RootState, AppDispatch>
export const stopAppListening = listener.stopListening as TypedStopListening<RootState, AppDispatch>

export const {middleware: listenerMiddleware} = listener
